<template>
  <i
    class="pi pi-times text-red-500 cursor-pointer rounded-full border border-solid border-red-400 p-1 ml-4"
    @click="onClick()"
  />
</template>

<script setup lang="ts">
defineProps<{
  onClick: () => void;
}>();
</script>
